import { render, staticRenderFns } from "./AxReCaptcha.vue?vue&type=template&id=30f82a7a&"
import script from "./AxReCaptcha.vue?vue&type=script&lang=ts&"
export * from "./AxReCaptcha.vue?vue&type=script&lang=ts&"
import style0 from "./AxReCaptcha.vue?vue&type=style&index=0&id=30f82a7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports